import { type FC } from 'react';
import { Flex, Link, useBreakpointValue } from '@chakra-ui/react';
import parse from 'html-react-parser';
import { FormattedMessage } from 'react-intl';
import { Text } from '../../../../../ui-components';
import { buildPDPUrl } from '../../../../../utils/product-utils';
import { getProductTileId } from '../../../utils/search-page-utils';
import { ProductImage } from '../../product-image';
import type { TextSize } from '../../../../../ui-components';
import type { SearchProductTileProps } from '../../search-listing/SearchListing';

export const ProductTileRecipe: FC<SearchProductTileProps> = ({
    loading,
    fetchPriority,
    onClick,
    ...product
}) => {
    const { id, name, brand, c_imageUrl } = product;
    const url = buildPDPUrl(product);

    const nameTextSize = useBreakpointValue<TextSize>({ base: 'small', md: 'base' }) ?? 'small';

    const componentId = getProductTileId(id);
    return (
        <Link
            id={componentId}
            data-testid={componentId}
            href={url}
            _hover={{ textDecoration: 'none' }}
            w="100%"
            onClick={onClick}
        >
            <Flex direction="column" gap={3}>
                <ProductImage
                    id={id}
                    name={name}
                    imageUrl={c_imageUrl}
                    loading={loading}
                    fetchPriority={fetchPriority}
                />

                <Flex direction="column" gap={1} className="product-tile-info">
                    <Text id={`recipe-${id}-name`} size={nameTextSize}>
                        {parse(name)}
                    </Text>

                    <Text id={`recipe-${id}-brand`} size="xs">
                        <FormattedMessage
                            id="by-brand"
                            defaultMessage="By {brand}"
                            values={{ brand: parse(brand) }}
                        />
                    </Text>
                </Flex>
            </Flex>
        </Link>
    );
};
